import { CompIconButtonCore } from '../core/icon-button/comp'

export const CompIconButton = CompIconButtonCore
